import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import businessLoansImage from "../../assets/static/business/loan_proof_of_income.png"; // Update with your image path
import { Container, Row, Col, Button } from 'react-bootstrap';

function BusinessLoans() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Business Loans? We’ve got you covered." 
        description="Kontriman offers various ways to support your Business Loans – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere." 
        imageUrl={FlightImage}
    />
 <div>
      <Container fluid className="my-5 bg-custom">
        <Container className='container-padding'>
          <Row className="flex-column flex-md-row">
            {/* Image column */}
            <Col md={6} className="order-2 order-md-1">
              <img
                src={businessLoansImage}
                alt="Business Loans"
                className="img-fluid"
              />
            </Col>

            {/* Text column */}
            <Col md={6} className="d-flex align-items-center order-1 order-md-2">
              <div>
                <h1 className='custom_heading'>Business Loans at Kontriman</h1>
                <p>
                  Fuel your business growth with flexible loan options from Kontriman. Whether you need capital for expansion, inventory, or working capital, our tailored business loans are designed to support your unique needs.
                </p>
                <p>
                  Benefit from competitive interest rates, convenient repayment plans, and expert financial advice to help you succeed. Our straightforward application process ensures quick approvals and access to funds when you need them most.
                </p>
                <p><strong>Key Features:</strong></p>
                <ul>
                  <li>Competitive interest rates and flexible terms</li>
                  <li>Loans tailored for SMEs and cooperatives</li>
                  <li>Simple and fast application process</li>
                  <li>Dedicated support from business loan specialists</li>
                  <li>Transparent fees with no hidden charges</li>
                </ul>

                <a href="/login">
                  <Button className='custom-button mt-3'>Apply for a Business Loan</Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>

      <Footer></Footer>
    </div>
  );
}

export default BusinessLoans;
